import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: [{
        "type": 0,
        "value": "Du kan välja när du vill få betalt efter att beställningar skickas. Utbetalningar initieras baserat på det utbetalningsalternativ som valts, men det kan ta 3–5 arbetsdagar innan utbetalningen syns på ditt konto, beroende på din banks behandlingstid. Din avgift för betalningsbehandling baseras på ditt val."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Utbetalning nästa dag"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 3,5 % + 0,30 USD"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "30-dagars utbetalning"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 2,4 % + 0,30 USD"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "60-dagars utbetalning"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 1,9 % + 0,30 USD"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: [{
        "type": 0,
        "value": "För att ändra ditt utbetalningsalternativ och motsvarande avgift för betalningsbehandling går du till "
      }, {
        "children": [{
          "type": 0,
          "value": "Kontoinställningar"
        }],
        "type": 8,
        "value": "AccountSettingLinkFormatting"
      }, {
        "type": 0,
        "value": " och väljer fliken "
      }, {
        "children": [{
          "type": 0,
          "value": "Utbetalning"
        }],
        "type": 8,
        "value": "PayoutLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: [{
        "type": 0,
        "value": "Ändringar gäller för alla framtida beställningar som görs efter att utbetalningsinställningen har uppdaterats. Kontakta oss för att ändra ditt utbetalningsalternativ för befintliga beställningar."
      }]
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: [{
      "type": 0,
      "value": "Du kan välja när du vill få betalt efter att beställningar skickas. Utbetalningar initieras baserat på det utbetalningsalternativ som valts, men det kan ta 3–5 arbetsdagar innan utbetalningen syns på ditt konto, beroende på din banks behandlingstid. Din avgift för betalningsbehandling baseras på ditt val."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH Next Day"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": 3 % i utbetalningsavgift tillkommer på både beställningen och fraktkostnaderna"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH 30 dagar"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": ingen avgift för utbetalning"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: [{
      "type": 0,
      "value": "För att ändra ditt utbetalningsalternativ och motsvarande avgift för betalningsbehandling går du till "
    }, {
      "children": [{
        "type": 0,
        "value": "Kontoinställningar"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": " och väljer fliken "
    }, {
      "children": [{
        "type": 0,
        "value": "Utbetalning"
      }],
      "type": 8,
      "value": "PayoutLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: [{
      "type": 0,
      "value": "Ändringar gäller för alla framtida beställningar som görs efter att utbetalningsinställningen har uppdaterats. Kontakta oss för att ändra ditt utbetalningsalternativ för befintliga beställningar."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};